import { EuiButton, EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import { isEmpty } from 'lodash';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userHasPermission } from '../../helper/auth';
import SectionCreationFlyout from './SectionCreationFlyout';

const AddSection = ({ isEditTableMode }) => {
    const [showFlyout, setShowFlyout] = useState(false);
    const history = useHistory();
    const permissions = useSelector((state) => state.permission.permission);
    const outletOrderingModes = useSelector((state) => state.outlet.orderingModes)?.find(
        (mode) => mode?.restaurant_ordering_mode?.tab === 'dine_in' && mode?.restaurant_ordering_mode?.status
    );

    const handleFlyoutState = useCallback(async () => {
        setShowFlyout((prevState) => !prevState);
    }, []);

    return (
        <>
            <EuiFlexGroup justifyContent='flexEnd'>
                <EuiFlexItem grow={false}>
                    <EuiButton
                        fill
                        disabled={
                            isEditTableMode ||
                            !userHasPermission(permissions, history.location.pathname, 'write') ||
                            isEmpty(outletOrderingModes)
                        }
                        onClick={handleFlyoutState}
                    >
                        Add Section
                    </EuiButton>
                </EuiFlexItem>
            </EuiFlexGroup>
            {showFlyout ? <SectionCreationFlyout closeFlyout={handleFlyoutState} /> : null}
        </>
    );
};

export default React.memo(AddSection);
